import { z } from "zod";

// Must be evaluated before any schema is created, so it is the first export of index.ts.
//
// Zod 4 probes `new Function("")` when it builds an object schema to decide whether it may compile ("JIT")
// parsers. Under a strict Content-Security-Policy (no `unsafe-eval`) that probe is reported as a violation on every
// page load, so in the browser the optimisation is switched off. The server keeps it.
if (typeof document !== "undefined") z.config({ jitless: true });
